import React from 'react';
import { Switch, Route, BrowserRouter as Router, Redirect } from 'react-router-dom';
import { isLoggedIn } from 'axios-jwt';

import {
    Dashboard,
    // Product
    ListProduct, ActionProduct, ListOrder, DetailOrder,
    //profile
    Infomation, Agency, User, ChangePass, AgencyAddress
} from '../modules';

// import layout
import Login from '../layouts/login';
import MainLayout from '../layouts/main';
import CONSTANT from '../config/constant';


const PrivateRoute = ({ component: Component, layout: Layout = MainLayout, ...rest }) => {
    const isLoggedIn = localStorage.getItem(CONSTANT.STORAGE_KEY_USER) ? true : false;
    const authed = isLoggedIn ? true : false;
    return (
        <Route
            {...rest}
            render={(props) => authed === true ? (
                <Layout>
                    <Component {...props} />
                </Layout>
            ) : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            }
        />
    )
}

export default function AppRouter() {
    return (
        <Router>
            <Switch>
                <Route path="/login" component={Login} />
                <PrivateRoute path="/" exact component={Dashboard} />
                <PrivateRoute path="/product" exact component={ListProduct} />
                <PrivateRoute path="/product/action" exact component={ActionProduct} />
                <PrivateRoute path="/product/action/:id" component={ActionProduct} />
                <PrivateRoute path="/order" component={ListOrder} />
                <PrivateRoute path="/order-detail/:id" component={DetailOrder} />
                {/* Product */}
                {/* <PrivateRoute path="/product" exact component={ListProduct}/>
                <PrivateRoute path="/product/action" exact component={ActionProduct}/>
                <PrivateRoute path="/product/action/:id" component={ActionProduct}/>
                <PrivateRoute path="/product/:idProduct/age" exact component={ListAge}/> */}
                {/* Info user */}
                <PrivateRoute path="/profile" exact component={Infomation} />
                <PrivateRoute path="/profile/change-pass" exact component={ChangePass} />
                <PrivateRoute path="/profile/user" exact component={User} />
                <PrivateRoute path="/profile/agency" exact component={Agency} />
                <PrivateRoute path="/profile/address" exact component={AgencyAddress} />

            </Switch>
        </Router>
    )
}

